'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./experience/components/pyHeroCarousel'));
    processInclude(require('./experience/components/videoComponent'));
    processInclude(require('./experience/popularCollectionCarousel'));
    processInclude(require('./experience/components/shopTheLooks'));
    processInclude(require('./search/initUspBanner'));
    processInclude(require('./carousels/edgeArrowCarousel'));
    processInclude(require('./experience/components/bgImageForPage'));
    processInclude(require('./bookAppointment'));
    processInclude(require('./experience/components/formWithVideo'));
    processInclude(require('./experience/components/flexibleContentBlock'));
    processInclude(require('./experience/components/bonusCard'));
    processInclude(require('./experience/components/imageWithText'));
    processInclude(require('./experience/components/twoCtaButtons'));
});
